package fr.manyverse.app.presentation.viewmodel

import fr.manyverse.app.domain.model.GameTable
import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.usecase.CreateGameTableUseCase
import fr.manyverse.app.domain.usecase.GetUniversesUseCase
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class GameConfigurationViewModel(
    private val createGameTableUseCase: CreateGameTableUseCase,
    private val getUniversesUseCase: GetUniversesUseCase
) : BaseViewModel() {

    private val _configState =
        MutableStateFlow<AsyncUiState<GameTable>>(AsyncUiState.Idle)
    val configState: StateFlow<AsyncUiState<GameTable>> = _configState.asStateFlow()

    private val _gameName = MutableStateFlow("")
    val gameName: StateFlow<String> = _gameName.asStateFlow()

    private val _universesState =
        MutableStateFlow<AsyncUiState<List<Universe>>>(AsyncUiState.Loading)
    val universesState: StateFlow<AsyncUiState<List<Universe>>> = _universesState.asStateFlow()

    private val _selectedUniverseId = MutableStateFlow<String?>(null)
    val selectedUniverseId: StateFlow<String?> = _selectedUniverseId.asStateFlow()

    fun loadUniverses(userId: String) {
        launchAsync(_universesState) { getUniversesUseCase(userId) }
    }

    fun selectUniverse(universeId: String) {
        _selectedUniverseId.value = universeId
    }

    fun updateGameName(name: String) {
        _gameName.value = name
    }

    fun createGameTable(gameMasterId: String) {
        val universeId = _selectedUniverseId.value ?: return
        launchAsync(_configState) {
            createGameTableUseCase(
                universeId = universeId,
                gameMasterId = gameMasterId,
                name = _gameName.value.trim(),
            )
        }
    }

    fun resetState() {
        resetState(_configState)
        _gameName.value = ""
        _selectedUniverseId.value = null
    }
}
